  <div class="b-input__checkbox-input">
    <fieldset class="b-input__checkbox-group">
      <div class="b-input__table" (click)="toggle($event)">
        <table>
          <tr>
            <td class="b-input__table-td" >
              <div class="b-input__checkbox-item b-input__table-tr">
              <input type="checkbox" [id]="id" [name]="name"  [ngModel]="value"
                [disabled]="useReviewMode || disabled" [attr.checked]="!!value" />
              <span class="b-checkmark" *ngIf="isLarge" style="pointer-events: none;"></span>
              <label class="b-input__checkbox-item-text b-input__checkbox-input-label" [for]="id"
                [innerHTML]="label" (click)="$event.stopPropagation()"></label>
            </div>
            </td>
          </tr>
        </table>
  
      </div>
    </fieldset>

  </div>
  <f-facet-info [isError]="true" [text]="error">
    <ng-content select="f-facet[name=error],[facet-error]"></ng-content>
  </f-facet-info>
  <f-facet-info [text]="info">
    <ng-content select="f-facet[name=info],[facet-info]"></ng-content>
  </f-facet-info>
